/** Accept local CMS page paths, including assigned checkout pages outside the shop root. */
export function safeCheckoutPath(value: string | undefined): string | undefined {
  if (!value || value.length > 240 || !value.startsWith("/") || /[\\?#\u0000-\u001f\u007f]/u.test(value)) return undefined;
  if (value === "/") return value;
  const segments = value.slice(1).replace(/\/$/u, "").split("/");
  return segments.every((segment, index) =>
    /^[a-z0-9]+(?:-[a-z0-9]+)*$/iu.test(segment)
    || (index === 0 && /^[a-z]{2,3}_[a-z0-9]{2,8}$/iu.test(segment))
  ) ? value : undefined;
}
